import { render, staticRenderFns } from "./BDXEditFormTPA.vue?vue&type=template&id=4c06ecbc&scoped=true"
import script from "./BDXEditFormTPA.vue?vue&type=script&lang=js"
export * from "./BDXEditFormTPA.vue?vue&type=script&lang=js"
import style0 from "./BDXEditFormTPA.vue?vue&type=style&index=0&id=4c06ecbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06ecbc",
  null
  
)

export default component.exports